const scrollToElement = (elementId: string) => {
  const currentElement = document.getElementById(elementId)
  if (currentElement) {
    window.scrollTo(0, currentElement.offsetTop - window.innerHeight / 2)
  }
}

export default scrollToElement
